import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  PaginatedPost,
  QueryFilterPostsArgs,
} from '@tribeplatform/gql-client/types'
import { PaginatedPostFields } from '@tribeplatform/gql-client/types/generated'
import {
  useQuery,
  UseQueryOptions,
  useTribeClient,
} from '@tribeplatform/react-sdk'
import { getFilterPostsKey } from '@tribeplatform/react-sdk/utils/keys'

type Props = {
  variables: QueryFilterPostsArgs
  fields?: PaginatedPostFields
  useQueryOptions?: UseQueryOptions<PaginatedPost, ClientError>
}

export const useFilterPosts = ({
  variables,
  fields,
  useQueryOptions,
}: Props) => {
  const { client } = useTribeClient()

  return {
    ...useQuery<PaginatedPost, ClientError>(
      getFilterPostsKey({ variables, fields }),
      () => client.posts.filterPosts(variables, fields),
      { ...useQueryOptions },
    ),
  }
}
